// RMI-2026-591 (react-refresh/only-export-components): split out of
// RealtimeContext.jsx, which now exports only the RealtimeProvider component.
import { createContext, useContext } from 'react';

export const RealtimeContext = createContext(null);

export const useRealtime = () => {
  const ctx = useContext(RealtimeContext);
  if (!ctx) return { subscribe: () => () => {}, status: 'INACTIVE' };
  return ctx;
};
